import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api`;

const SetupPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API}/auth/setup-password`, {
        email,
        otp,
        new_password: newPassword,
        name
      });

      toast.success("Password set successfully! Please login with your new password.");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/login");
    } catch (error) {
      console.error("Setup error:", error);
      toast.error(error.response?.data?.detail || "Failed to set password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 bg-white border border-gray-200">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-semibold text-gray-900 mb-2">Set Up Your Account</h1>
          <p className="text-gray-500">Create your password to get started</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              data-testid="setup-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 border-gray-300"
            />
          </div>

          <div>
            <Label htmlFor="otp">One-Time Password (from email)</Label>
            <Input
              id="otp"
              data-testid="setup-otp"
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
              className="mt-1 border-gray-300"
            />
          </div>

          <div>
            <Label htmlFor="name">Your Name</Label>
            <Input
              id="name"
              data-testid="setup-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="mt-1 border-gray-300"
            />
          </div>

          <div>
            <Label htmlFor="password">New Password</Label>
            <Input
              id="password"
              data-testid="setup-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="mt-1 border-gray-300"
            />
          </div>

          <div>
            <Label htmlFor="confirm">Confirm Password</Label>
            <Input
              id="confirm"
              data-testid="setup-confirm"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="mt-1 border-gray-300"
            />
          </div>

          <Button
            data-testid="setup-submit"
            type="submit"
            className="w-full bg-gray-900 hover:bg-gray-800"
            disabled={loading}
          >
            {loading ? "Setting up..." : "Set Password"}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default SetupPassword;